import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'df-thank-you-forgot',
  templateUrl: './thank-you-forgot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThankYouForgotComponent {}
